import { CHECKIN_ACTION_TYPES, CHECKIN_REQUEST } from "../../actions/utilities";

const initialState = {
  attendanceData: [],
  attendanceDetail: null,
  loading: false,
  error: null,
  removeLoading: false,
};

const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECKIN_REQUEST.DELETE_CHECKIN_REQUEST:
      return {
        ...state,
        removeLoading: true,
      };
       case CHECKIN_REQUEST.DELETE_CHECKIN_SUCCESS:
      return {
        ...state,
        removeLoading: false,
        attendanceData: state.attendanceData.filter(
            (user) => user.id !== action.payload
          ),
      };
       case CHECKIN_REQUEST.DELETE_CHECKIN_FAILURE:
      return {
        ...state,
        removeLoading: false,
      };
    case CHECKIN_ACTION_TYPES.CREATE_CHECKIN_REQUEST:
      return { ...state, loading: true, error: null };

    case CHECKIN_ACTION_TYPES.CREATE_CHECKIN_SUCCESS:
      return {
        ...state,
        loading: false,
        attendanceData: [...state.attendanceData, action.payload],
      };

    case CHECKIN_ACTION_TYPES.CREATE_CHECKIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHECKIN_REQUEST.GET_ALL_CHECKINS_REQUEST:
      return { ...state, loading: true, error: null };

    case CHECKIN_REQUEST.GET_ALL_CHECKINS_SUCCESS:
      return {
        ...state,
        loading: false,
        attendanceData: action.payload,
      };

    case CHECKIN_REQUEST.GET_ALL_CHECKINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        attendanceData: [],
      };
    case CHECKIN_REQUEST.GET_CHECKIN_REQUEST:
      return { ...state, loading: true, attendanceDetail: null, error: null };
    case CHECKIN_REQUEST.GET_CHECKIN_SUCCESS:
      return { ...state, loading: false, attendanceDetail: action.payload };
    case CHECKIN_REQUEST.GET_CHECKIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CHECKIN_REQUEST.UPDATE_CHECKIN_REQUEST:
      return { ...state, loading: true, error: null };
    case CHECKIN_REQUEST.UPDATE_CHECKIN_SUCCESS:
      return {
        ...state,
        loading: false,
        attendanceData: state.attendanceData.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
        attendanceDetail: action.payload,
      };
    case CHECKIN_REQUEST.UPDATE_CHECKIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default attendanceReducer;
